import { Meeting, MeetingAccountSource, MeetingCertifierSource } from '../../objects/Meeting';

angular.module("tromanWeb").factory('MeetingState', ['$q', 'tromanServer', 'dialogService', function ($q, tromanServer, dialogService) {

    function getMeeting(id) {
        if (id) {
            return tromanServer.Meetings.get(id);
        } else {
            var meeting = new Meeting();
            meeting.MeetingType = 0;
            meeting.AccountSource = MeetingAccountSource.missionOrganization;
            meeting.CertifierSource = MeetingCertifierSource.missionOrganization;
            return $q.when(meeting);
        }
    }

    class MeetingState {
        constructor(meeting) {
            this.meeting = meeting;
        }

        static create(id) {
            return getMeeting(id)
                .then(x => new MeetingState(x))
                .catch(err => {
                    dialogService.error(err);
                    return $q.reject(err);
                });
        }
    }

    return MeetingState;
}]);
